export default "__VITE_ASSET__STHDBhuH__"